import { useQuery } from "@apollo/client";
import { Center, SimpleGrid } from "@chakra-ui/react";
import { Tag } from "antd";
import { useContext, useState } from "react";
import { IProduct } from "../../services/graphql/Product";
import { FAVORITES } from "../../services/graphql/query/Favorites";
import { useCheckUser } from "../../services/hooks/useCheckUser";
import { CardProducts } from "../CardProduct/CardProduct";
import { ProductSkeletonLoading } from "../ProductSkeletonLoading/ProductSkeletonLoading";

export const Favorites = () => {
  useCheckUser();

  const [loading, setLoading] = useState<boolean>(true);
  const [dataProducts, setDataProducts] = useState<IProduct[]>([]);
  const { fetchMore } = useQuery(FAVORITES, {
    onCompleted: (data) => {
      const { favorites } = data;
      let products_favorites: IProduct[] = [];
      if (favorites.length) {
        favorites.map((favorite: any) => {
          products_favorites.push(favorite.product);
        });
      }
      setDataProducts(products_favorites);
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
    },
  });
  return (
    <>
      {loading ? (
        <SimpleGrid minChildWidth="200px" spacing="40px">
          <ProductSkeletonLoading />
        </SimpleGrid>
      ) : dataProducts.length ? (
        <SimpleGrid minChildWidth="200px" spacing="40px">
          {dataProducts.map((product: IProduct) => (
            <CardProducts
              dataProduct={product}
              finallyFavorite={() => {
                setLoading(true);
                fetchMore({})
                  .then((dataFavorites) => {
                    const { data } = dataFavorites;
                    const { favorites } = data;
                    let products_favorites: IProduct[] = [];
                    if (favorites.length) {
                      favorites.map((favorite: any) => {
                        products_favorites.push(favorite.product);
                      });
                    }
                    setDataProducts(products_favorites);
                    setLoading(false);
                  })
                  .catch(() => {
                    setLoading(false);
                  });
              }}
            />
          ))}
        </SimpleGrid>
      ) : (
        <Center>
          <Tag>NO TIENES PRODUCTOS EN FAVORITOS &#128532;</Tag>
        </Center>
      )}
    </>
  );
};
